import { render, staticRenderFns } from "./attendance-settings.vue?vue&type=template&id=279754bc"
import script from "./attendance-settings.vue?vue&type=script&lang=js"
export * from "./attendance-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports